const standingWoodyProfileHeights = [25, 42, 92];

export default standingWoodyProfileHeights;
